import { IExtraLogs } from './extra-logs.interface';
import { LogTypesEnum } from '../enums';

export interface ICreateTripLogDto {
    message: string;
    datetime?: string;
    source?: string;
    createdBy?: string;
    type?: LogTypesEnum;
    seenBy?: string[];
    extra?: IExtraLogs;
}
